// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dots-container .dot{width:13px;height:13px;border:1px solid rgba(211,211,211,.5);background-color:rgba(211,211,211,.5);border-radius:10px;margin-right:11px;display:inline-block}.dots-container .active-dot{background-color:#ff5964;border-color:#ff5964}", ""]);
// Exports
module.exports = exports;
